<template>
  <div>
    <modal name="registration-needed"
           class="vue-dialog modal-registration-needed"
           height="auto"
           :minWidth="250"
           :maxWidth="500"
           :adaptive="true"
           ref="modal"
           @opened="$emit('open')"
           :clickToClose="false">
      <div class="dialog-content">
        <div class="dialog-c-title"
             v-word:modal.registrationNeeded.header></div>
        <div class="dialog-c-text"
             v-word:modal.registrationNeeded.text></div>
        <div v-if="wordingsEditable"
             @click.prevent="close"
             class="modal-dialog-close"
             title="Close dialog"></div>
        <div class="links">
          <a @click.prevent="!wordingsEditable && onAlreadyRegistered()"
             v-word:modal.registrationNeeded.button.alreadyRegistered>
          </a>
          <br>
          <a @click.prevent="!wordingsEditable && onRegister()"
             v-word:modal.registrationNeeded.button.register>
          </a>
        </div>
      </div>
      <div class="vue-dialog-buttons">
      </div>
    </modal>
  </div>
</template>

<script>
import * as mixins from '../mixins';
import jsCookie from 'js-cookie';

const cookieName = 'p7regDialogShown';

export default {
  mixins: [mixins.wordedPage],
  methods: {
    open() {
      if (!jsCookie.get(cookieName)) {
        this.$modal.show('registration-needed');
      }
    },
    close() {
      this.$modal.hide('registration-needed');
    },
    onAlreadyRegistered() {
      this.setCookie();
      this.close();
    },
    onRegister() {
      this.setCookie();
      this.$router.push({ path: 'registration-1' });
    },
    setCookie() {
      jsCookie.set(cookieName, Date.now(), { expires: 20*365, path: '' });
    },
    onWordingReady() {
      setTimeout(() => {
        this.$refs['modal'].updateRenderedHeight();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/modals/RegistrationNeeded.vue